"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var ModelSelect_vue_1 = __importDefault(require("vue-search-select/src/lib/ModelSelect.vue"));
var StatusPreview_vue_1 = __importDefault(require("../status-preview/StatusPreview.vue"));
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetching = true;
        _this.jobs = [];
        _this.selectOptions = [];
        _this.selectedOptionJob = { value: '', text: '' };
        _this.selectedJob = null;
        _this.selectOptionsSpecialization = [];
        _this.selectedOptionSpecialization = { value: '', text: '' };
        return _this;
    }
    App.prototype.created = function () {
        this.fetchDataFromElement();
    };
    Object.defineProperty(App.prototype, "disableActions", {
        get: function () {
            return this.fetching;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(App.prototype, "disableSpecialization", {
        get: function () {
            return this.disableActions || this.selectOptionsSpecialization.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    App.prototype.onSelectedOptionJobChange = function (newSelectedOption) {
        var job = this.jobs.find(function (job) {
            return job.name === newSelectedOption.value;
        });
        if (!job) {
            this.selectedJob = null;
            return;
        }
        this.selectedJob = job;
        this.selectOptionsSpecialization = job.specializations.map(this.mapToOption);
        this.setSelectSpecialization(this.selectedOptionSpecialization.value);
    };
    App.prototype.fetchDataFromElement = function () {
        var _this = this;
        return new Promise(function (resolve) {
            var _a;
            var jsonElement = document.querySelector('#job-previews');
            if (!jsonElement) {
                throw new Error('Data not found');
            }
            var jobs = JSON.parse((_a = jsonElement.textContent) !== null && _a !== void 0 ? _a : '');
            _this.selectOptions = jobs.map(_this.mapToOption);
            if (_this.jobName) {
                var selectedOptionJob = _this.selectOptions.find(function (option) {
                    return option.value === _this.jobName;
                });
                if (selectedOptionJob) {
                    _this.selectedOptionJob = selectedOptionJob;
                    if (_this.specializationName) {
                        _this.$nextTick(function () {
                            _this.setSelectSpecialization(_this.specializationName);
                        });
                    }
                }
            }
            _this.jobs = jobs;
            _this.fetching = false;
            resolve({ previews: _this.jobs });
        });
    };
    App.prototype.mapToOption = function (preview) {
        return {
            value: preview.name,
            text: preview.translation,
        };
    };
    App.prototype.cleanSelected = function () {
        this.selectedOptionJob = { value: '', text: '' };
    };
    App.prototype.cleanSelectedSpecialization = function () {
        this.selectedOptionSpecialization = { value: '', text: '' };
    };
    App.prototype.setSelectSpecialization = function (specialization) {
        var selectedOption = this.selectOptionsSpecialization.find(function (selectOption) {
            return selectOption.value === specialization;
        });
        if (!selectedOption) {
            selectedOption = { value: '', text: '' };
        }
        this.selectedOptionSpecialization = selectedOption;
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], App.prototype, "jobName", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: '' })
    ], App.prototype, "specializationName", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ default: 'vertical' })
    ], App.prototype, "layout", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            default: function () {
                return {
                    name: '',
                    placeholder: 'Select job',
                    label: 'Job',
                };
            }
        })
    ], App.prototype, "inputJob", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            default: function () {
                return {
                    name: '',
                    placeholder: 'Select specialization',
                    label: 'Specialization',
                };
            }
        })
    ], App.prototype, "inputSpecialization", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)('selectedOptionJob')
    ], App.prototype, "onSelectedOptionJobChange", null);
    App = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                ModelSelect: ModelSelect_vue_1.default,
                StatusPreview: StatusPreview_vue_1.default,
            }
        })
    ], App);
    return App;
}(vue_1.default));
exports.default = App;
